import {
  ActionTypes,
  AddFavoriteAction,
  AddSelectedInvitation,
  ChangePage,
  ClearInvitations,
  FetchInvitationDetailFailAction,
  FetchInvitationDetailStartAction,
  FetchInvitationDetailSuccessAction,
  FetchInvitationsFailAction,
  FetchInvitationsStartAction,
  FetchInvitationsSuccessAction,
  RemoveFavoriteAction,
  SetFavoritesAction,
  SetSelectedInvitation,
  UpdateFiltersAction,
} from './types';

import { invitation, invitationDetails, InvitationFavorite, InvitationsFilters } from '@/types/legacyInvitation';

const fetchInvitationsStart = (): FetchInvitationsStartAction => ({
  type: ActionTypes.FETCH_INVITATIONS_START,
});

const fetchInvitationsSuccess = (payload: invitation[], totalItems: number): FetchInvitationsSuccessAction => ({
  type: ActionTypes.FETCH_INVITATIONS_SUCCESS,
  payload,
  totalItems,
});

const addSelectedInvitation = (payload: invitation): AddSelectedInvitation => ({
  type: ActionTypes.ADD_SELECTED_INVITATION,
  payload,
});

const fetchInvitationsFail = (payload: string): FetchInvitationsFailAction => ({
  type: ActionTypes.FETCH_INVITATIONS_FAIL,
  payload,
});

const fetchInvitationDetailStart = (): FetchInvitationDetailStartAction => ({
  type: ActionTypes.FETCH_INVITATION_DETAIL_START,
});

const fetchInvitationDetailSuccess = (payload: invitationDetails[]): FetchInvitationDetailSuccessAction => ({
  type: ActionTypes.FETCH_INVITATION_DETAIL_SUCCESS,
  payload,
});

const fetchInvitationDetailFail = (payload: string): FetchInvitationDetailFailAction => ({
  type: ActionTypes.FETCH_INVITATION_DETAIL_FAIL,
  payload,
});

const changePage = (payload: number): ChangePage => ({
  type: ActionTypes.CHANGE_PAGE,
  payload,
});

const setSelectedInvitation = (payload: invitation): SetSelectedInvitation => ({
  type: ActionTypes.SET_SELECTED_INVITATION,
  payload,
});

const clearInvitations = (): ClearInvitations => ({
  type: ActionTypes.CLEAR_INVITATIONS,
});
const updateFilters = (payload: InvitationsFilters): UpdateFiltersAction => ({
  type: ActionTypes.UPDATE_FILTERS,
  payload,
});
const addFavoritePromo = (payload: InvitationFavorite): AddFavoriteAction => ({
  type: ActionTypes.ADD_FAVORITE,
  payload,
});
const removeFavoritePromo = (payload: string): RemoveFavoriteAction => ({
  type: ActionTypes.REMOVE_FAVORITE,
  payload,
});
const setFavoritesPromo = (payload: InvitationFavorite[]): SetFavoritesAction => ({
  type: ActionTypes.SET_FAVORITES,
  payload,
});

export {
  fetchInvitationsStart,
  fetchInvitationsSuccess,
  fetchInvitationsFail,
  fetchInvitationDetailStart,
  fetchInvitationDetailSuccess,
  fetchInvitationDetailFail,
  changePage,
  addSelectedInvitation,
  setSelectedInvitation,
  clearInvitations,
  updateFilters,
  addFavoritePromo,
  removeFavoritePromo,
  setFavoritesPromo,
};
